exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".add-start-ad-stage{padding:20px}.add-start-ad-stage .stage-header{border-bottom:1px solid #d6d6d6;padding-bottom:20px}.add-start-ad-stage .stage-header h4{font-weight:700;size:16px;color:#333;border-left:4px solid #e65454;padding-left:5px}.add-start-ad-stage .add-pop-form{width:600px;margin:20px auto}.add-start-ad-stage .add-pop-form .create-btn{text-align:center;margin-top:40px;padding-top:40px;border-top:1px solid #d6d6d6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/configPush/start-ad/add-start-ad/add-start-ad.scss
// module id = 543
// module chunks = 2